module.exports = __webpack_public_path__ + "static/nutrition_design-c64c8040d7e24f278aad185998a021ba.mp4";